import React from "react";

export const LogoMark = ({ size = 28, className = "", title = "Clenchless" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    width={size}
    height={size}
    fill="none"
    role="img"
    aria-label={title}
    className={className}
    data-testid="clenchless-mark"
  >
    <g transform="rotate(-12 50 50)">
      <path
        d="M 82.9 31 A 38 38 0 1 0 82.9 69"
        stroke="currentColor"
        strokeWidth="7"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="95" cy="50" r="3.2" fill="currentColor" />
    </g>
  </svg>
);
